export const ADORNMENT_ALLOWANCE = {
  start: "--AdornmentAllowance-start",
  end: "--AdornmentAllowance-end",
} as const;
